/* =======================================================================
   assets/price-fetch.js.liquid
   – Dynamic sweepstakes entries + variant-aware pricing
   ======================================================================= */

/* ---------- helpers --------------------------------------------------- */
function sanitizeId(str) {
    return String(str).replace(/\D/g, '');
  }
  
  function formatSubtotal(cents) {
    const s = String(cents);
    return s.length > 2 ? parseFloat(`${s.slice(0, -2)}.${s.slice(-2)}`) : cents / 100;
  }
  
  /* ---------- core GraphQL fetch & DOM update --------------------------- */
  function runSweepstakesFetch(cardEl) {
    if (!cardEl?.isConnected) return; // node got removed; guard
  
    const productId    = `gid://shopify/Product/${cardEl.dataset.productId}`;
    const platformId   = `gid://shopify/Shop/${cardEl.dataset.shopGid}`;
    const subtotal     = parseFloat(cardEl.dataset.subtotal);
    const sweepstakeId = sanitizeId(cardEl.dataset.sweepstakeId) || 'default';
    // console.debug('Sweepstakes fetch:', { productId, platformId, subtotal, sweepstakeId });
  
    const query = `
      query QuerySweepstakeDetailsByProductId(
        $platform: String!
        $platformId: String!
        $productIds: [String!]
      ) {
        sweepstakeDetailsByProductId(
          platform: $platform
          platformId: $platformId
          productIds: $productIds
        ) {
          id
          entryManagement
          productsAllowedByDefault
          bonusEntriesDefault
          isActive
          products(productIds: $productIds) {
            productId
            productAllowed
            productBonusEntries
            productMultiplier
          }
        }
      }
    `;
  
    const variables = {
      platform:   'Shopify',
      platformId: platformId,
      productIds: [productId],
    };
  
    (async () => {
      try {
        const res = await fetch('https://backend.cleansweeps.app/graphql', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ query, variables }),
        });
        if (!res.ok) throw new Error(`Network error: ${res.status}`);
  
        const json = await res.json();
        if (json.errors?.length) {
          console.error('GraphQL errors:', json.errors);
          return;
        }
  
        const details = json.data?.sweepstakeDetailsByProductId;

        if (!details?.length) return;
  
        const matched =
          details.find(d => sanitizeId(d.id) === sweepstakeId) ||
          details.find(d => d.isActive) ||
          details[0];
        if (!matched) return;
  
        /* ----- calculations -------------------------------------------- */
        const entryMgmt   = JSON.parse(matched.entryManagement || '{}');
        const dollarSpent = Number(entryMgmt.dollarSpent ?? 1) || 1;
        const entriesPer  = Number(entryMgmt.entryPer ?? 0) || 0;
        const roundUp     = entryMgmt.roundUp ?? true;
        const roundFn     = roundUp ? Math.ceil : Math.floor;
  
        let finalMultiplier = entriesPer;
        let finalEntries;
  
        if ((!matched.products?.length) && matched.productsAllowedByDefault) {
          finalEntries =
            roundFn((entriesPer / dollarSpent) * roundFn(subtotal)) +
            Number(matched.bonusEntriesDefault ?? 0);
        } else {
          // Prefer the product that matches the current productId
          const prod = matched.products?.find(p => p.productId === productId) ?? matched.products?.[0];
          if (!prod?.productAllowed) {
            cardEl.innerHTML = '';
          return;
          } else {
            const prodMult = Number(prod.productMultiplier ?? 1) || 1;
            finalEntries =
              roundFn((entriesPer / dollarSpent) * roundFn(subtotal) * prodMult) +
              Number(prod.productBonusEntries ?? 0);
            // Do not show built-in multiplier directly; use rounded entriesPer * prodMult for the badge
            finalMultiplier = roundFn(entriesPer * prodMult);
          }
        }
  
        // Normalize to string for injection
        if (typeof finalEntries === 'number') {
          finalEntries = Number.isFinite(finalEntries) ? String(finalEntries) : '--';
        }
  
        /* ----- DOM updates — render EXACT markup with inline styles ------ */
        const entriesText =
          finalEntries === 'Product Not Eligible'
            ? 'Product Not Eligible'
            : `${finalEntries} Entries`;
  
        const showBadge = Number(finalMultiplier) > 1;

        if (!cardEl.__pfMetaId) {
            const rnd = Math.random().toString(36).slice(2, 8);
            cardEl.__pfMetaId = `pf-meta-${cardEl.dataset.productId}-${sweepstakeId}-${rnd}`;
          }
          if (window.location.href.indexOf('-customizer') !== -1) { return; }

          const scopeId = cardEl.__pfMetaId;
  
          const html = `
          <style>
          @media screen and (max-width: 1024px){
            /* neutralize theme's .product-item .caption div { width:100% } for THIS instance only */
            #${scopeId} .product-metafields-entries,
            #${scopeId} .product-entry-badge{
              width:auto!important;
              max-width:max-content!important;
              flex:0 0 auto!important;
              display:inline-flex!important;
            }
          
            /* also stop UL children from flex-stretching */
            #${scopeId} > ul > *{flex:0 0 auto!important}
          }
            /* Mobile-only, scoped to THIS instance via #${scopeId} */
            @media (max-width: 749px) {
              /* center the whole injected block, regardless of parent layout */
              #${scopeId} {
                display: block !important;
                width: 100% !important;
                margin-left: auto !important;
                margin-right: auto !important;
                text-align: center !important;
                
              }
              /* center row contents even if theme uses list styling */
              #${scopeId} > ul {
                display: flex !important;
                justify-content: center !important;
                padding-left: 0 !important;
                margin: 0 !important;
              }
              #${scopeId} .product-metafields-entries {
                justify-content: center !important;
              }
              /* tighten vertical padding only for THIS instance's badge */
              #${scopeId} .product-metafields-entries{flex-wrap:nowrap!important}
                #${scopeId} .entries{white-space:nowrap!important}

                padding-top: -12px !important;
                padding-bottom: 2px !important;
                height: auto !important;
              }
            }

              
          </style>
        
          <div id="${scopeId}"
               style="visibility: ;position:  "
               data-product-id="${cardEl.dataset.productId}"
               data-pf-type="ProductVariantMetafield"
               class="sc-oByig fSTnty pf-27_">
            <ul data-pf-type="VariantMetafieldValue" class="sc-iUwgAI kzjoPm pf-29_">
              <div class="product-metafields-entries" style="display:flex;align-items:center;gap:8px;">
                <span class="entries" style="display:flex;align-items:center;gap:6px;font-size:14px;line-height:1;">
                  <span class="product-item-icon" style="display:inline-block">🎟</span>
                  <span class="entries_meta_cl"
                        style="display:inline-block;font-weight:700;letter-spacing:-0.02em;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,'Noto Sans',sans-serif;">
                    ${entriesText}
                  </span>
                </span>
                <div class="product-entry-badge"
                     style="display:${showBadge ? 'inline-flex' : 'none'};align-items:center;justify-content:center;height:20px;padding:0 6px;border-radius:0px;font-weight:1000 !important;font-size:14px;letter-spacing:-0.02em;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,'Noto Sans',sans-serif;background: linear-gradient(180deg, rgba(91, 255, 230, 1), rgba(72, 255, 178, 1) 100%) !important; color: #000000 !important;">
                  ${showBadge ? `${finalMultiplier}x` : ''}
                </div>
              </div>
            </ul>
          </div>
        `.trim();
        
      
  
        // Inject into the card container
        cardEl.innerHTML = html;
  
      } catch (err) {
        console.error('Sweepstake fetch error:', err);
      }
    })();
  }
  
  /* ---------- variant-change awareness ---------------------------------- */
  function setupVariantSync() {
    const productJsonEl = document.querySelector(
      '[type="application/json"][data-product]'
    );
    if (!productJsonEl) return;
  
    const productJson   = JSON.parse(productJsonEl.textContent || '{}') || {};
    const productIdAttr = String(productJson.id || ''); // may be blank on some templates
  
    const variantData = productJson.variants || [];
    if (!variantData.length) return;
  
    const priceByVariant = Object.fromEntries(
      variantData.map(v => [Number(v.id), parseInt(v.price, 10)])
    );
  
    const variantSelect = document.querySelector('select[name="id"]');
    if (!variantSelect) return;
  
    let prevSubtotal = null;
  
    const refresh = () => {
      const vid   = Number(variantSelect.value);      // ensure numeric key
      const cents = priceByVariant[vid];
      if (!cents) {
        setTimeout(refresh, 60);                      // theme still fetching JSON
        return;
      }
  
      const subtotal = formatSubtotal(cents);
      if (subtotal === prevSubtotal) return;
      prevSubtotal = subtotal;
  
      // Re-scan for any newly added price cards (AJAX-y themes)
      scan();
  
      document
        .querySelectorAll(
          `[data-price-context="card"][data-product-id="${productIdAttr}"]`
        )
        .forEach(card => {
          card.dataset.subtotal = subtotal;
          runSweepstakesFetch(card);
        });
    };
  
    variantSelect.addEventListener('change', refresh);
    window.addEventListener('popstate', refresh); // covers ?variant= pushes
  }
  
  /* ---------- per-card init -------------------------------------------- */
  function initOneCard(el) {
    if (el.__priceCardInit) return; // idempotent
    el.__priceCardInit = true;
    runSweepstakesFetch(el);
  }
  
  /* ---------- scanning utilities --------------------------------------- */
  function scan(root = document) {
    root
      .querySelectorAll('[data-price-context="card"]')
      .forEach(initOneCard);
  }
  
  /* ---------- bootstrapping -------------------------------------------- */
  document.addEventListener('DOMContentLoaded', () => {
    scan();
    setupVariantSync(); // set up only once on product pages
  });
  document.addEventListener('shopify:section:load', e => scan(e.target));
  
  const observer = new MutationObserver(muts => {
    for (const m of muts) {
      m.addedNodes.forEach(node => {
        if (node.nodeType !== 1) return;
        if (node.matches?.('[data-price-context="card"]')) initOneCard(node);
        if (node.querySelector) scan(node);
      });
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  